// extracted by mini-css-extract-plugin
export default {"container":"better-modal_container__yAXhX","truncate-table":"better-modal_truncate-table__6olcA","table-text-faded":"better-modal_table-text-faded__oYFek","header":"better-modal_header__S2ydU","noJsxHeader":"better-modal_noJsxHeader__ISwjZ","close":"better-modal_close__9NkGR","hide":"better-modal_hide__rVNqT","overlay":"better-modal_overlay__5TJ-N"};
    if(module.hot) {
      // 1792500652905
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  